import React from 'react';
import pdfImage from "../../../assets/images/allNotices/pdf.png";
import '../../../assets/css/pages/guidelines/sections/guidelineCardStyle.scss';
import {fileDownload} from "../../../utils/fetchData";
import downloadFileType from "../../../config/downloadFileType.json";

const GuidelineCard = ({guideline}) => {
    const {titleEn, iconTag, iconBase64, backgroundColor, pdfEnTag} = guideline;
    const handleDownload = async (fileName) => {
        await fileDownload(fileName, downloadFileType.GUIDELINE);
    }
    return (
        <div className="guideline-custom-card">
            <div className="guideline-custom-card-header" style={{background: backgroundColor}}>
                <img
                    src={iconBase64 ? `data:image/jpg;base64,${iconBase64}` : "http://119.148.4.26:8088/cbc-portal/images/guideline/img-1.png"}
                    alt={iconTag}
                />
            </div>
            <div className="guideline-custom-card-body">
                <p className="guideline-custom-card-title">{titleEn}</p>
                <div>
                    {pdfEnTag && <a role='button' title={pdfEnTag} className="pdf-download-btn">
                        <img
                            onClick={() => handleDownload(pdfEnTag)}
                            width="20"
                            src={pdfImage}
                            alt={iconTag}
                        />
                    </a>}
                </div>
            </div>
        </div>
    );
};

export default GuidelineCard;
